const USE_BFF = import.meta.env.VITE_USE_BFF !== 'false';

export const formConfig = [
  {
    step: 0,
    label: "Claim Details",
    title: "Let's start your claim",
    buttons: [[{ label: "Verify Details", type: "button", action: "next" }]],
    fields: [
      {
        name: "policyNo",
        label: "Policy Number",
        component: "input",
        placeholder: "Enter",
        required: true,
        onChangeType: "policyNo",
      },
      {
        name: "nameOfLifeAssured",
        label: "Name of Life Assured",
        component: "input",
        placeholder: "Enter",
        required: true,
        transform: "titleCase",
      },
      {
        name: "dob",
        label: "Date of Birth of Life Assured",
        component: "date",
        required: true,
        rules: { required: "Date of Birth is required" },
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(),
      },
      {
        name: "claimantName",
        label: "Claimant's Name",
        component: "input",
        placeholder: "Enter",
        required: true,
        transform: "titleCase",
      },
      {
        name: "claimantMail",
        label: "Claimant's Email Id",
        component: "input",
        type: "email",
        placeholder: "Enter",
        required: true,
      },
    ],
  },
  {
    step: 1,
    label: "Death Details",
    title: "Death claim details",
    buttons: [
      [
        { label: "Save as Draft", type: "button", action: "draft" },
        { label: "Next", type: "button", action: "next" },
      ],
    ],
    fields: [
      {
        name: "policyNo",
        label: "Policy Number",
        component: "input",
        placeholder: "Enter",
        required: true,
        disabledWhenFilled: true,
        rules: { required: "Policy No is required" },
      },
      {
        name: "nameOfLifeAssured",
        label: "Name of Life Assured",
        component: "input",
        placeholder: "Enter",
        required: true,
        disabledWhenFilled: true,
        rules: { required: "Name of Life Assured is required" },
      },
      {
        name: "dob",
        label: "Date of Birth of Life Assured",
        component: "date",
        required: true,
        disabledWhenFilled: true,
        rules: { required: "Date of Birth is required" },
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(),
      },
      {
        name: "deathDate",
        label: "Date of Death",
        component: "date",
        required: true,
        rules: { required: "Date of Death is required" },
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(),
      },
      {
        name: "deathCause",
        label: "Cause of Death",
        component: "select",
        required: true,
        options: ["Natural", "Unnatural", "Natural Calamity ", "Others"],
        rules: { required: "Cause of death is required" },
      },
      {
        name: "deathReason",
        label: "Reason of Death",
        component: "input",
        placeholder: "Enter",
        required: true,
        rules: { required: "Reason of death is required" },
      },
    ],
  },
  {
    step: 2,
    label: "Claimant Details",
    buttons: [
      [{ label: "Back", type: "button", action: "prev" }],
      [
        { label: "Save as Draft", type: "button", action: "draft" },
        { label: "Next", type: "button", action: "next" },
      ],
    ],
    sections: [
      {
        title: "Claimant Details",
        fields: [
          {
            name: "claimantName",
            label: "Name",
            component: "input",
            placeholder: "Enter",
            required: true,
            disabledWhenFilled: true,
            rules: { required: "Name is required" },
          },
          {
            name: "relationWithLifeAssurance",
            label: "Relationship with Assured",
            component: "select",
            required: true,
            options: [
              "Wife",
              "Husband",
              "Son",
              "Daughter",
              "Mother",
              "Father",
              "Others",
            ],
            rules: { required: "Relation is required" },
          },
          {
            name: "claimantMail",
            label: "Email",
            component: "input",
            type: "email",
            placeholder: "Enter",
            required: true,
            disabledWhenFilled: true,
          },
          {
            name: "mobileNo",
            label: "Mobile Number",
            component: "input",
            placeholder: "e.g. 98762 72383",
            required: true,
            maxLength: 10,
            onChangeType: "mobileNo",
          },
          {
            name: "address",
            label: "Address",
            component: "input",
            placeholder: "Enter",
            required: true,
            rules: { required: "Address is required" },
          },
          {
            name: "pincode",
            label: "Pin Code",
            component: "input",
            placeholder: "Enter",
            required: true,
            maxLength: 6,
            onChangeType: "pincode",
          },
          {
            name: "country",
            label: "Country",
            component: "select",
            required: true,
            options: ["India", "USA", "UK"],
            rules: { required: "Country is required" },
          },
          {
            name: "state",
            label: "State",
            component: "select",
            required: true,
            options: ["Delhi", "Maharashtra", "Karnataka"],
            rules: { required: "State is required" },
          },
        ],
      },
      {
        title: "Bank Details",
        fields: [
          {
            name: "accountNumber",
            label: "Account Number",
            component: "input",
            required: true,
            maxLength: 16,
          },
          {
            name: "bankName",
            label: "Name of Bank",
            component: "input",
            required: true,
          },
          {
            name: "ifscCode",
            label: "IFSC Code",
            component: "input",
            required: true,
          },
          {
            name: "micrCode",
            label: "MICR Code",
            component: "input",
            required: true,
          },
          {
            name: "branchName",
            label: "Branch Name",
            component: "input",
            required: true,
          },
        ],
      },
    ],
  },
  {
    step: 3,
    label: "Other Policies",
    title: "Other Policy Details",
    buttons: [
      [
        { label: "Back", type: "button", action: "prev" },
        { label: "Skip", type: "button", action: "skip" },
      ],
      [
        { label: "Save as Draft", type: "button", action: "draft" },
        { label: "Next", type: "button", action: "next" },
      ],
    ],
    fieldArray: "policies",
    fields: [
      {
        name: "otherPolicyNo",
        label: "Policy Number",
        component: "input",
        placeholder: "Enter",
        required: true,
        onChangeType: "policyNo",
      },
      {
        name: "commencementDate",
        label: "Date of Commencement",
        component: "date",
        required: true,
        rules: { required: "commencement date is required" },
      },
      {
        name: "sumAssured",
        label: "Sum Assured",
        component: "input",
        type: "number",
        placeholder: "Enter",
        required: true,
        rules: { required: "please enter sum assured" },
      },
      {
        name: "icName",
        label: "Name of the Insurance Company",
        component: "input",
        placeholder: "Enter",
        required: true,
        rules: { required: "please enter IC name" },
      },
      {
        name: "claimStatus",
        label: "Claim Status",
        component: "input",
        placeholder: "Enter (Pending/Approved/Rejected)",
        required: true,
        rules: {
          required: "Provide claim status",
          validate: (value) => {
            const allowed = ["pending", "approved", "rejected"];
            return (
              allowed.includes(value?.toLowerCase()) ||
              "Status must be Pending, Approved, or Rejected"
            );
          },
        },
      },
    ],
  },
  {
    step: 4,
    label: "Documents",
    title: "Upload Documents",
    buttons: [
      [
        { label: "Save as Draft", type: "button", action: "draft" },
        {
          label: "Submit",
          type: "submit",
          action: "submit",
          disabledWhen: "noConsent",
        },
      ],
    ],
    showConsent: true,
    description:
      "You can upload jpg, png or pdf file formats with a maximum file size limit of 10mb.",
    fields: [
      {
        name: "Death Certificate of Life Assured",
        label: "Death Certificate of Life Assured",
        component: "file",
        required: true,
      },
      {
        name: "Photo ID Proof of Nominee",
        label: "Photo ID Proof of Nominee",
        component: "file",
        required: true,
      },
      {
        name: "Address Proof of Nominee",
        label: "Address Proof of Nominee",
        component: "file",
        required: true,
      },
      {
        name: "Bank Document",
        label: "Bank Document",
        component: "file",
        required: true,
      },
      {
        name: "Policy Schedule",
        label: "Policy Schedule",
        component: "file",
        required: true,
      },
      {
        name: "Medical Records",
        label: "Medical Records",
        component: "file",
        required: true,
      },
      {
        name: "Upload an Image",
        label: "Upload an Image",
        component: "file",
        required: true,
      },
      {
        name: "Driving License of Life Assured",
        label: "Driving License of Life Assured",
        component: "file",
        required: true,
      },
      {
        name: "Viscera Report if any",
        label: "Viscera Report if any",
        component: "file",
        required: false,
      },
    ],
  },
];

const getBaseURL = () => {
  if (typeof Liferay !== 'undefined' && Liferay.ThemeDisplay) {
    if (USE_BFF) {
       return Liferay.ThemeDisplay.getPortalURL() + '/o/bff-api/proxy';
    } 
    return Liferay.ThemeDisplay.getPortalURL();
  }

  return window.location.origin || 'http://localhost:8080';
};

/**
 * Returns the page title from document.title (part before " - ").
 * Use this to show the page name in form headers instead of hardcoding (e.g. "Track a Grievance" vs "Track a query").
 * @returns {string|null} Page title or null when document.title is empty or missing
 */
export const getPageTitle = () => {
  if (typeof document === 'undefined' || !document.title) {
    return null;
  }
  const titleName = document.title.split(' - ')[0];
  const trimmed = titleName != null ? String(titleName).trim() : '';
  return trimmed || null;
};

export const API_BASE_URL = getBaseURL();

// API endpoints
export const API_ENDPOINTS = {
  JOURNEY_MASTERS: "/o/restService/journeyMasters",
};

// Pincode master configuration for Journey Masters
export const PINCODE_MASTER_TYPE = "getProductPincodes";
export const PINCODE_PRODUCT_NAME = "superSurakshaElite";

// File size constants
export const FILE_SIZE_LIMIT_MB = 2;
export const FILE_SIZE_LIMIT_BYTES = FILE_SIZE_LIMIT_MB * 1024 * 1024;

// Email validation constants
export const MAX_EMAIL_LENGTH = 254;

/**
 * Career form email regex: local part only . and _ allowed before @ (no hyphen);
 * each segment in local part must be at least 3 chars;
 * domain labels (alphanumeric + hyphens), TLD min 2 letters.
 * ReDoS-safe: no nested quantifiers or unbounded lookaheads (SonarQube S5858).
 */
export const CAREER_EMAIL_REGEX =
  /^[A-Za-z0-9]{3,}([._][A-Za-z0-9]{3,})*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,})+$/;

// Retry constants
export const MAX_RETRY_COUNT = 2;

// Error messages
export const ERROR_MESSAGES = {
  GENERIC_ERROR: "We couldn’t complete this action right now. Please try again in a moment.",
  EMAIL_REQUIRED: "Email is required.",
  EMAIL_TOO_LONG: "Email address is too long.",
  EMAIL_INVALID: "Please enter a valid email address.",
  VALUE_INVALID: (fieldName) => `enter valid ${fieldName}`,
  VALUE_REQUIRED: (fieldName) => `enter ${fieldName}`,
  FIELD_REQUIRED: (fieldName) => `${fieldName} is required.`,
  FILE_REQUIRED: "File is required.",
  INVALID_FILE_TYPE: "Upload valid file type",
  FILE_SIZE_EXCEEDED: (maxSizeMB) => `File size must be ${maxSizeMB} MB or less.`,
  MOBILE_REQUIRED: "Mobile number is required.",
  MOBILE_INVALID: "Please enter a valid mobile number.",
  NAME_REQUIRED: "Name is required.",
  MOBILE_NUMBER_REQUIRED: "Mobile number is required.",
  DEPARTMENT_REQUIRED: "Department is required.",
  RESUME_REQUIRED: "Resume upload is required.",
  INVALID_RESPONSE_FORMAT: "Invalid response format from departments API.",
  UPLOAD_NO_DOCUMENT_ID: "File upload completed but no document ID was obtained. Cannot submit application.",
  SUBMISSION_FAILED: "Application submission failed.",
  UNABLE_TO_REFRESH_TOKEN: "Unable to refresh authentication token.",
  REQUEST_FAILED_AFTER_RETRIES: (retryCount) => `Request failed after ${retryCount} retries.`,
  ALREADY_APPLIED_90_DAYS: "You have already applied for this position. Please try after 90 days",
  OTP_FAILED: "OTP generation failed. Please try again later",
};

// Success messages
export const SUCCESS_MESSAGES = {
  APPLICATION_SUBMITTED: 'Application submitted successfully.',
  FORM_SUBMITTED: 'Your request has been submitted successfully. We’ll take it from here and keep you updated on the next steps.',
  FORM_SUBMITTEDBL:'Thanks! We’ve shared the nearest branch details on your mobile number'
};

// UI labels
export const UI_LABELS = {
  LOADING_DEPARTMENTS: 'Loading departments...',
  SELECT_DEPARTMENT: 'Select department',
  NO_OPENINGS_MODAL_MESSAGE: "We don't have any suitable openings for you at this moment. Please try again later.",
  UPLOAD_RESUME: (maxSizeMB) => `Max ${maxSizeMB} MB`,
  SUBMITTING: 'Submitting...',
  SUBMIT: 'Submit',
  MAX_SIZE_TEXT: (maxSizeMB) => `Max ${maxSizeMB} MB`,
};

// HTTP status codes
export const HTTP_STATUS = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
};

export const PREMIUMOFFSET_ERRORMSG = "We are sorry, but this policy does not currently qualify for the online Premium Offset facility. Please ensure your policy is active and registered for ECS. For further assistance, please contact our customer helpline at 1800 102 1010 or visit the nearest branch.";
      

const reviews = Array.from({ length: 50 }, (_, index) => ({
  id: index + 1,
  fullName: `Customer ${index + 1}`,
  designation: "Professional",
  location: "Kanpur",
  description:
    "The best thing about IndusInd Nippon Life is that their people clarify all the policy details. Everything was explained properly and the overall experience was excellent.",
  imageThumbnil:
    "https://cdn-icons-png.flaticon.com/512/149/149071.png",
  videoURL: "https://youtu.be/X5eGbTi5ze0",
}));

export default reviews;